import { useSelector, useDispatch } from 'react-redux';
import { useState, useEffect } from 'react';
import { CartoLayer, colorBins} from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';
import getPinnedTooltipCoordinate from 'utils/getPinnedTooltipCoordinate';
import { useAppState } from 'components/contexts/State';

export const HISTORICALHCCLINTERSECTION_LAYER_ID = 'historicalHCCLIntersectionLayer';

export const CATEGORY_COLORS = {
  Parcel: [0, 100, 214],
};

const layerConfig = {
  title: 'VRU Intersection Crashes',
};

function HistoricalHCCLIntersectionLayer() {
  const dispatch = useDispatch();
  const { historicalHCCLIntersectionLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>  selectSourceById(state, historicalHCCLIntersectionLayer?.source));

  const cartoLayerProps = useCartoLayerProps({ source });

  const viewState = useSelector((state) => state.carto.viewState);
  const pointRadiusMinPixels = viewState.zoom >= 7 ? 4 : 2;
   let [domainArray, setDomainArray] = useState([1, 2, 4, 7, 10]);
    const {isVRUCrashesFilterActive, pinnedTooltip, setPinnedTooltip} = useAppState();
  
    useEffect(() => { 
      if (isVRUCrashesFilterActive) {
        setDomainArray([1, 2, 4, 7, 10]);
         
      } else {
         setDomainArray([1, 25, 75, 150, 200]);
      }
    }, [isVRUCrashesFilterActive]);
  if (historicalHCCLIntersectionLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: HISTORICALHCCLINTERSECTION_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: historicalHCCLIntersectionLayer.visible,
      opacity: historicalHCCLIntersectionLayer.opacity,
      getFillColor: colorBins({
        attr: 'Crash_Volume',
        domain: domainArray,
        colors: [
          [235, 74, 64, 0],
          [235, 74, 64, 64],
          [235, 74, 64, 128],
          [235, 74, 64, 192],
          [235, 74, 64, 255],
        ],
      }),
      pointRadiusMinPixels: pointRadiusMinPixels,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: HISTORICALHCCLINTERSECTION_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad?.(data);
      },
      onClick: (info) => {
        console.log('Clicked feature:', info);
        if (info?.object) {
          const html = htmlForFeature({ feature: info.object });
          if (pinnedTooltip?.html === html) {
            setPinnedTooltip(null);
          } else {
            setPinnedTooltip({
              html,
               postMileInfo: info.object.properties,
              coordinate: getPinnedTooltipCoordinate(info),
            });
          }
        }
      },
      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
            }),
          };
        }
      },
    });
  }
}

export default HistoricalHCCLIntersectionLayer;
